import React from 'react'
import { Box, Theme, useTheme } from '@mui/material'
import { Splide, SplideSlide } from '@splidejs/react-splide'

import { IImageDataProps } from '../../models/imageData'

import '@splidejs/react-splide/dist/css/splide.min.css'

interface ISwiperProps {
  itemData: IImageDataProps[]
  maxHeight?: number
}

const defaultSettings = {
  maxHeight: 500,
}

const Swiper: React.FC<ISwiperProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <Box component='section' sx={{ marginTop: theme.spacing(3), marginBottom: theme.spacing(3) }}>
      <Splide options={{
        gap: '10px',
        pagination: false,
      }}
      >
        {props.itemData.map((item, idx) =>
          <SplideSlide key={idx} style={{ alignSelf: 'center' }}>
            <Box maxHeight={props.maxHeight ?? defaultSettings.maxHeight} display='flex' alignContent='center' justifyContent='center'>
              <img
                src={item.img} alt={item.title} style={{
                  maxHeight: props.maxHeight ?? defaultSettings.maxHeight,
                  maxWidth: '100%',
                }}
              />
            </Box>
          </SplideSlide>,
        )}
      </Splide>
    </Box>
  )
}
export default Swiper
